<template>
<div>
  <div class="goback-large">
    <i class="fal fa-arrow-left c-pointer" @click="clickBackButton"></i> {{mainTitle}}
  </div>
  <div>
    <el-steps :active="activeStep" finish-status="success">
      <el-step title="IP 검색 대역 설정"></el-step>
      <el-step title="스캔 방식 선택"></el-step>
      <el-step title="Telnet / SSH"></el-step>
      <el-step title="스케줄 설정"></el-step>
      <el-step title="모델링 요약"></el-step>
    </el-steps>
    <w-ip-search-setting v-if="activeStep == 0" @click-next-step="clickNextStep" :checked-ip-search-rows="checkedIpSearchRows"></w-ip-search-setting>
    <w-scan-method-setting v-if="activeStep == 1" :checked-ip-search-rows="checkedIpSearchRows" @click-pre-step="clickPreStep" @click-next-step="clickNextStep"></w-scan-method-setting>
    <w-connection-setting v-if="activeStep == 2" @click-pre-step="clickPreStep" @click-next-step="clickNextStep" :checked-connection-rows="checkedConnectionRows"></w-connection-setting>
    <w-schedule-setting v-if="activeStep == 3" @click-pre-step="clickPreStep" @click-next-step="clickNextStep" :schedule-data="scheduleData"></w-schedule-setting>
    <w-modeling-summary v-if="activeStep == 4" @click-back-button="clickBackButton" @click-pre-step="clickPreStep" :checked-ip-search-rows="checkedIpSearchRows" :checked-connection-rows="checkedConnectionRows" :schedule-data="scheduleData"></w-modeling-summary>
  </div>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import WIpSearchSetting from './IpSearchSetting';
import WScanMethodSetting from './ScanMethodSetting';
import WConnectionSetting from './ConnectionSetting';
import WScheduleSetting from './ScheduleSetting';
import WModelingSummary from './ModelingSummary';

export default {
  name: 'WRegistMagician',
  components: {
    WIpSearchSetting,
    WScanMethodSetting,
    WConnectionSetting,
    WScheduleSetting,
    WModelingSummary,
  },
  props: {
    registMagicianInfo: Object,
  },
  data() {
    return {
      activeStep: 0,
      checkedIpSearchRows: [],
      checkedConnectionRows: [],
      scheduleData: null,
      mainTitle: '네트워크 등록 마법사',
    };
  },
  watch: {
    registMagicianInfo: {
      immediate: true,
      handler(object) {
        if (!isNil(object)) {
          this.mainTitle = '모델링 스케줄 수정';
          this.checkedIpSearchRows = object.ipSearchList;
          this.checkedConnectionRows = object.connectionCredentialList;
          this.scheduleData = object.scheduleData;
          this.activeStep = 3;
        }
      },
    },
  },
  methods: {
    clickBackButton(load) {
      this.activeStep = 0;
      this.checkedIpSearchRows = [];
      this.$emit('click-back-button', load);
    },
    clickNextStep(data, type) {
      this.insertRowsByType(data, type);
      this.activeStep = this.activeStep + 1;
    },
    clickPreStep(data, type) {
      this.insertRowsByType(data, type);
      this.activeStep = this.activeStep - 1;
    },
    insertRowsByType(data, type) {
      if (!isNil(data)) {
        if (data instanceof Array) {
          if (isEqual(type, 'checkedIpSearchRows')) {
            this.checkedIpSearchRows = data;
          } else if (isEqual(type, 'checkedConnectionRows')) {
            this.checkedConnectionRows = data;
          }
        } else {
          this.scheduleData = data;
        }
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/components/RegistMagician.vue